import { render, staticRenderFns } from "./SoftwareVersionForm.vue?vue&type=template&id=4d8575ca&scoped=true&"
import script from "./SoftwareVersionForm.vue?vue&type=script&lang=js&"
export * from "./SoftwareVersionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8575ca",
  null
  
)

export default component.exports